import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IInvoiceRecipient } from '../../types/types';
import { ClientProfile } from './ClientProfile';
import Heading from '../../../../../generic-components/Heading';
import Button from '../../../../../generic-components/Button';
import { STYLES, TEXTS } from '../../consts/consts';
import { PRESENTOR_ACTION_TYPES } from './InvoiceClientSection';
import { useStore } from '../../../../../store';
import { ReactComponent as ClearIcon } from '../../../../../assets/icons/svg/shared/ic-shared-clear.svg';
import { ReactComponent as EditIcon } from '../../../../../assets/svg/edit_pen_icon.svg';

const {
  INVOICE_CREATION: {
    RECIPIENT_PRESENTOR: { CONTAINER: activePresentorContainerStyles },
  },
} = STYLES;

const {
  INVOICE_CREATION: {
    INVOICE_CLIENT_SECTION: { ACTIVE_RECIPIENT_PRESENTOR: activePresentorContainerTexts },
  },
} = TEXTS;

interface IProps {
  client: IInvoiceRecipient;
  onClick: (type?: string, idx?: number) => void;
  id?: string;
}

export const ActiveRecipientPresentor = ({ client, onClick, id }: IProps) => {
  const { t } = useTranslation();
  const setInvoiceDataToUpdate = useStore((state) => state.setInvoiceDataToUpdate);
  const invoiceData = useStore((state) => state.invoiceData);

  useEffect(() => {
    if (invoiceData) {
      const clientToUpdate = { ...client };
      const invoiceDataToUpdate = { ...invoiceData };
      if (clientToUpdate?.phone) {
        clientToUpdate.phone = `+1${clientToUpdate?.phone?.replace(/[^0-9]/g, '')}`;
      }
      invoiceDataToUpdate.invoiceRecipient = { ...clientToUpdate };
      setInvoiceDataToUpdate(invoiceDataToUpdate);
    }
  }, [client]);

  return (
    <div className={activePresentorContainerStyles.WRAPPER}>
      <div id={id || ''} className={`${activePresentorContainerStyles.CLIENT_PROFILE_WRAPPER}`}>
        <ClientProfile onClick={onClick} id={id || ''} singleMode clientData={client} />
        <div className='flex flex-row  px-[16px]'>
          <div className='p-[2px] rounded-md flex flex-col justify-center '>
            <Button
              onClick={() => onClick(PRESENTOR_ACTION_TYPES.CLEAR)}
              className={activePresentorContainerStyles.ACTION_CLEAR_CLIENT}
              id='editClientDetailsButton'
              childElement={<ClearIcon />}
            />
          </div>
          <div className='p-[2px] rounded-md flex flex-col justify-center'>
            <Button
              onClick={() => onClick(PRESENTOR_ACTION_TYPES.EDIT)}
              className={activePresentorContainerStyles.ACTION_EDIT_CLIENT}
              id='editClientDetailsButton'
              childElement={<EditIcon />}
            />
          </div>
        </div>
      </div>
      <div className={activePresentorContainerStyles.ACTIONS_WRAPPER}>
        {false && <Heading title='|' className={activePresentorContainerStyles.ACTIONS_SEPARATOR} />}
        {false && (
          <Button
            onClick={() => onClick(PRESENTOR_ACTION_TYPES.CLEAR)}
            className={activePresentorContainerStyles.ACTION_CLEAR_CLIENT}
            id='clearClientDetailsButton'
            childElement={
              <Heading
                title={t(activePresentorContainerTexts.ACTIONS.CLEAR)}
                className={activePresentorContainerStyles.ACTION_CLEAR_CLIENT_TITLE}
              />
            }
          />
        )}
      </div>
    </div>
  );
};
